import React from 'react'

import { predefinedDateHelpers } from '../helpers'

const DateHelpers = ({ helpers, updateDate }) => {
    const renderHelpers = () => {
        return helpers.map((h) => {
            const helper = typeof h === 'string' ? predefinedDateHelpers[h] : h

            if (!helper) {
                throw Error('The helper ' + h + ' could not be found')
            }

            return (
                <div
                    className={'r-datecalendar-helper'}
                    onClick={(e) => {
                        updateDate(helper.setDate())
                    }}
                >
                    {helper.name}
                </div>
            )
        })
    }

    return <div className={'r-datecalendar-helpers'}>{renderHelpers()}</div>
}

export default DateHelpers
